(function () {
    'use strict';

    angular
        .module('app.promotionalImages')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'promotionalimages',
                  config: {
                      abstract: true,
                      url: '/promotionalimages',
                      template: '<ui-view/>',
                      settings: {
                              authMode: 1
                      },
                      resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                     }
                  },
              },
            {
                state: 'promotionalimages.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/promotionalImages/list.html?v=' + opsIncludeVersion,
                    controller: 'PromotionalImagesListController',
                    controllerAs: 'vm',
                    title: 'Promotional Images',
                 
                }
            },
            {
                state: 'promotionalimages.details',
             config: {
                 url: '/detail/:id',
                 templateUrl: 'app/promotionalImages/details.html?v=' + opsIncludeVersion,
                 controller: 'PromotionalImageDetailsController',
                 controllerAs: 'vm',
                 title: 'Promotional Images Details',
             }
            }
          
        ];
    }
})();
